import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Error404 from "../pages/Error404";
import Home from "../pages/Home";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" index element={<Home />} />

        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
